
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductGradeHandComponent } from './product-grade-hand.component';
import { AnimatedHandModule } from '@app/shared/ui/animated-hand/animated-hand.module';
import { ProductGradeHandContainer } from './product-grade-hand.container';

@NgModule({
    imports: [
        CommonModule,
        AnimatedHandModule
    ],
    exports: [
        ProductGradeHandContainer,
        ProductGradeHandComponent
    ],
    declarations: [
        ProductGradeHandContainer,
        ProductGradeHandComponent
    ],
    providers: []
})
export class ProductGradeHandModule {
}
